<template>
  <div class="skeleton">
    <!-- Верхние карточки -->
    <div class="skeleton__cards">
      <div v-for="i in 4" :key="i" class="skeleton__card">
        <div class="skeleton__line skeleton__line--sm"></div>
        <div class="skeleton__line skeleton__line--md"></div>
      </div>
    </div>

    <!-- График и круг -->
    <div class="skeleton__middle">
      <div class="skeleton__chart">
        <div class="skeleton__line skeleton__line--md"></div>
        <div class="skeleton__box"></div>
      </div>
      <div class="skeleton__pie">
        <div class="skeleton__line skeleton__line--md"></div>
        <div class="skeleton__circle"></div>
      </div>
    </div>

    <!-- Таблица -->
    <div class="skeleton__table">
      <div class="skeleton__line skeleton__line--md"></div>
      <div class="skeleton__table-rows">
        <div v-for="i in 5" :key="i" class="skeleton__table-row">
          <div class="skeleton__line skeleton__line--xs"></div>
          <div class="skeleton__line skeleton__line--sm"></div>
          <div class="skeleton__line skeleton__line--sm"></div>
          <div class="skeleton__line skeleton__line--xs"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
// Тут логики нет, просто скелетон
</script>

<style scoped>
/* Общие стили */
.skeleton {
  padding: 2rem;
  background: #0f0f0f;
  color: #fff;
  min-height: 120vh;
}

/* Анимация мерцания */
@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.4; }
  100% { opacity: 1; }
}
.skeleton__line,
.skeleton__box,
.skeleton__circle {
  background: #2a2a2a;
  border-radius: 0.5rem;
  animation: pulse 1.5s infinite ease-in-out;
}

/* Верхние карточки */
.skeleton__cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1.5rem;
  margin-bottom: 2rem;
}
.skeleton__card {
  background: #1a1a1a;
  border-radius: 1rem;
  padding: 1rem;
  box-shadow: 0 0.2rem 0.5rem rgba(0,0,0,0.4);
}
.skeleton__line--xs { height: 1rem; width: 4rem; }
.skeleton__line--sm { height: 1.2rem; width: 6rem; margin-bottom: 0.8rem; }
.skeleton__line--md { height: 1.5rem; width: 10rem; margin-bottom: 1rem; }

/* Средний блок */
.skeleton__middle {
  display: grid;
  grid-template-columns: 2fr 1fr;
  gap: 2rem;
  margin-bottom: 2rem;
}
.skeleton__chart {
  background: #1a1a1a;
  border-radius: 1rem;
  padding: 1.5rem;
}
.skeleton__box {
  height: 20rem;
  width: 100%;
  margin-top: 1rem;
}
.skeleton__pie {
  background: #1a1a1a;
  border-radius: 1rem;
  padding: 1.5rem;
  text-align: center;
}
.skeleton__circle {
  height: 12rem;
  width: 12rem;
  border-radius: 50%;
  margin: 1rem auto 0;
}

/* Таблица */
.skeleton__table {
  background: #1a1a1a;
  border-radius: 1rem;
  padding: 1.5rem;
}
.skeleton__table-rows {
  margin-top: 1.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.skeleton__table-row {
  display: flex;
  align-items: center;
  gap: 2rem;
}
</style>
